












import mixins from 'vue-typed-mixins';
import LocationBasedMixin from '@/Shared/LocationBasedMixin';
import { Attachment } from './Attachment';
import constants from '@/constants';
import fileSaver from 'file-saver';
import VatsAPI from '@/Shared/VatsAPI';

export default mixins(LocationBasedMixin).extend({
    props: {
        location: {
            type: String,
            default: false,
            required: true
        },
        attachments: {
            type: Array,
            default: new Array<Attachment>(),
            required: true
        }
    },
    data() {
        return {

        };
    },
    methods: {
        async downloadAttachment(item: Attachment) {
            const response = (await VatsAPI.post<Blob>(`/${this.$typedStore.state.currentLocation.urlSegment}/citations/attachment`, item,
            {
                headers: {
                    accept: constants.OctetMimeType
                },
                responseType: 'blob'
            }));
            fileSaver.saveAs(response.data, item.fileName!);
        }
    },
});
